import { Button as UIButton } from "@mui/material";
import Edit2LineIcon from "remixicon-react/Edit2LineIcon";
import JTooltip from "$components/JTooltip/JTooltip";
import { useStyles } from "../styles";

type EditButtonProps = {
  onClick: () => void;
  canEdit: boolean;
  isProjectDisabled: boolean;
};

export default function EditButton({
  onClick,
  canEdit,
  isProjectDisabled,
}: EditButtonProps) {
  const clasx = useStyles();

  return (
    <JTooltip
      title={
        (isProjectDisabled && "Vous ne pouvez pas éditer un projet inactif.") ||
        (!canEdit && "Vous n'avez pas les droits pour éditer ce projet.")
      }
    >
      <UIButton
        className={clasx.editButton}
        onClick={onClick}
        disabled={isProjectDisabled || !canEdit}
      >
        <Edit2LineIcon />
      </UIButton>
    </JTooltip>
  );
}
